import {Button, styled} from "@mui/material";

export const HoverElevationButton = styled(Button)(() => ({
    borderRadius: '10px',
    minWidth: 'unset',

    '&:hover': {
        boxShadow: '0px 3px 6px 0px rgba(69, 77, 102, 0.50)'
    },
    '&:active': {
        boxShadow: '0px 0px 10px 0px rgba(69, 77, 102, 0.30) inset'
    },
    '& span': {
        whiteSpace: 'nowrap',
    }
}));
